import { createSelector } from 'reselect';

export const authUserStateSelector = state => state.auth.user;

export const currentUserSelector = createSelector(
  authUserStateSelector,
  (authState) => authState.currentUser
);

export const currentUserInfoSelector = createSelector(
  authUserStateSelector,
  (authState) => (authState.currentUserInfo || {})
);

export const isSessionLoadedSelector = createSelector(
    authUserStateSelector,
    (authState) => (authState.isSessionLoaded)
);

export const isCurrentUserLoggedSelector = createSelector(
  authUserStateSelector,
  (authState) => {
    return authState.currentUser != null;
  }
);




// WEBPACK FOOTER //
// ./src/app/modules/auth/store/auth-user/selectors.ts